export default __webpack_public_path__ + "static/media/bg2.4a714fdc.png";